import { render, staticRenderFns } from "./courseSelectionDefault.vue?vue&type=template&id=78b6d220&scoped=true"
import script from "./courseSelectionDefault.vue?vue&type=script&lang=js"
export * from "./courseSelectionDefault.vue?vue&type=script&lang=js"
import style0 from "./courseSelectionDefault.vue?vue&type=style&index=0&id=78b6d220&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6d220",
  null
  
)

export default component.exports